import { IConfigCatClient, PollingMode, getClient } from '@configcat/sdk';

import { env } from '../env';

let configCatClient: IConfigCatClient | null = null;

const createConfigCatClient = () =>
	getClient(env.configcat.devConfigcatKey, PollingMode.AutoPoll, {
		baseUrl: 'https://takeda-cdn.configcat.com',
	});

export const getConfigCatClient = () => {
	if (!configCatClient) configCatClient = createConfigCatClient();
	return configCatClient;
};
